<template>
  <div class="cardtemplate" >
    <div class="top"> 
      <el-button size="medium" @click="$router.go(-1)">返回</el-button>
      <el-button size="medium" type="primary" @click="dialogVisible=true">初始化放学卡</el-button>
      <el-button size="medium" type="primary" v-if="classimglist.length" @click="downImg">导出</el-button>
    </div>
     <div class="body" :style="{height: `${maxH}px`}" >
       <div class="body-box">
              <div  class="box-top">卡模板</div>  
              <div class="img">            
                <div class="img-box">
                  <uploader  :showModeCover="true" :key="1"  :multiple="false" v-model="imglistone" :extList="['jpeg', 'jpg', 'png']" showMode="cover"  showResult="image"></uploader>
                  <div class="img-b-box">点击更换放学卡模板正面</div>
                </div>
                <div class="img-box">
                  <uploader :showModeCover="true"  :key="2"   :multiple="false" v-model="imglisttwo" :extList="['jpeg', 'jpg', 'png']" showMode="cover"  showResult="image"></uploader>
                  <div class="img-b-box">点击更换放学卡模板反面</div>
                </div>
              </div>
              <div  class="box-top"  v-if="classimglist.length" >放学路队卡</div> 
              <div class="img"  v-if="classimglist.length" >
                  <img :src="item.cardUrl"  :key="index" v-for="(item,index) in classimglist" class="urlimg" alt="">
              </div>
       </div>
       <el-dialog title="初始化放学卡" :close-on-press-escape='false' :close-on-click-modal='false' :visible.sync="dialogVisible" width="700px" :lock-scroll="false" :modal-append-to-body='false'>
		 <div class="toptxt">
             根据套餐设置，共需{{cardCount}}张放学卡，请在如下文本框中输入{{cardCount}}个卡号，每行一个
         </div>
         <el-input v-model="cardNoList"  type="textarea" :rows="cardCount"  placeholder="请输入卡号"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="addSchooloverComboCardStaticList()">确 定</el-button>
			</span>
		</el-dialog>
          
    </div>      
  </div>
</template>
<script>
import {getSchooloverComboCardStaticList,addSchooloverComboCardStaticList,getSchooloverCombo} from '@/api/schoolRoadTeamPackage';
import mixins from "@/mixins/windowResize";
import Uploader from "@/components/Uploader/WebUploader";
import JSZip from 'jszip';
import FileSaver from "file-saver";
export default {
  components: {Uploader},
  data() {
    return {
        imglistone:[{fileUrl:"http://sysfile-1251008840.cos.ap-shanghai.myqcloud.com/hechenglogo/fangxueka.png",id:""}],
        imglisttwo:[{fileUrl:"https://cdnfile-10043692.file.myqcloud.com/admin/images/onecardsolution/beimian.jpg",id:""}],
        classimglist:[],
        cardCount:0,
        cardNoList:"",
        dialogVisible:false
    };
  },
  mixins: [mixins],
  created() {
      getSchooloverCombo(this.$route.query.id)
        .then((res) => {
          const data = res.data.data;
          if (res.data.code === 200) {
              if(data.frontUrl){
                   this.imglistone[0].fileUrl=data.frontUrl;
                   this.imglisttwo[0].fileUrl=data.rearCardUrl;
              }
              this.cardCount=data.cardCount;
          }
        })
        .catch();
        this.getSchooloverComboCardStaticList();
  },
  methods: {
      //下载图片
            downImg() {
                let blogTitle = '放学路队卡';
                let zip = new JSZip();
                let imgs = zip.folder(blogTitle);
                let baseList = [];
                let arr = [];
                for (let i = 0; i < this.classimglist.length; i++) {
                    arr.push(this.classimglist[i].cardUrl);
                }
                // arr.push(this.rearCardUrl);
                for (let i = 0; i < arr.length; i++) {
                    let image = new Image();
                    // 解决跨域 Canvas 污染问题
                    image.setAttribute('crossOrigin', 'anonymous');
                    image.onload = function () {
                        let canvas = document.createElement('canvas');
                        canvas.width = image.width;
                        canvas.height = image.height;
                        let context = canvas.getContext('2d');
                        context.drawImage(image, 0, 0, image.width, image.height);
                        let url = canvas.toDataURL(); // 得到图片的base64编码数据
                        canvas.toDataURL('image/png');
                        baseList.push(url.substring(22));// 去掉base64编码前的 data:image/png;base64,
                        if (baseList.length === arr.length && baseList.length > 0) {
                            for (let k = 0; k < baseList.length; k++) {
                                imgs.file('放学路队卡'+(k+1)+'.jpg', baseList[k], {base64: true})
                            }
                            zip.generateAsync({type: 'blob'}).then(function (content) {
                                FileSaver.saveAs(content, blogTitle + '.zip');
                            });
                        }
                    };
                    image.src = arr[i];
                }
            },
  getSchooloverComboCardStaticList(){
          getSchooloverComboCardStaticList(this.$route.query.id)
        .then((res) => {
          const data = res.data.data;
          if (res.data.code === 200) {              
              this.classimglist=data;              
          }
        })
        .catch();
       },
  addSchooloverComboCardStaticList(){    
      let list=this.cardNoList.split(/[(\r\n)\r\n]+/);
      for(let i=0;i<list.length;i++){
          let num=0
          for(let j=0;j<list.length;j++){
          if(list[i]==list[j]){
              num++
           }
          }
          if(num>1){
               this.$message.error(list[i]+'卡号存在重复');
               return;
          }
      }
        if(list.length!=this.cardCount){
          this.$message.error('请输入正确卡号数量');
           return;
        }
         addSchooloverComboCardStaticList({
              equipmentId:this.$route.query.id,//	学校id	number	学校ID
              rearCardUrl:this.imglisttwo[0].fileUrl,//	学生卡背面图片	string	
              frontUrl:this.imglistone[0].fileUrl,//	学生卡前面图片	string	
              cardNoList:list,//	学生卡样式编码	number	
         }).then(res => {
            if (res.data.code === 200) {
              this.$message.success("初始化成功，请稍后刷新");
              this.cardNoList=[];
              this.getSchooloverComboCardStaticList();
              this.dialogVisible=false;
            } else {
              this.$message.error(res.data.msg);
            }
          });
       
    }
  
  }
};
</script>
<style>
.cardtemplate .upload-file-item img {
  width: 300px !important;
  height: 200px !important;
  margin: 0;
  /* border: 1px dashed #409EFF; */
  box-sizing: border-box;
  margin: 0 !important;
      
}
.cardtemplate .upload-block-container .upload-file-item {
  height: 220px;
  width: 100%;
}
.cardtemplate .upload-file-item .file-name {
  display: none;
}

.cardtemplate  .img-b-box {
        position: absolute;
        bottom: -1px;
        left: 1px;
        width: 100%;
        text-align: center;
        color: #409EFF;
        height: 34px;
        line-height: 34px;
        background: #ecf5ff;
      }
  .cardtemplate     .el-icon-circle-plus-outline {
        font-size: 20px;
        margin-left: 10px;
        color: #c0c4cc;
        cursor: pointer;
        line-height: 40px;
      }
   .cardtemplate    .el-icon-circle-plus-outline:hover {
        color: #409EFF;
      }
      .img-upload.img-upload-cover{
        position: absolute;
        left: 0;
        top:0;
        right: 0;
        bottom:0;
        opacity: 0;
         width: 300px !important;
         height: 200px !important;
         display: block !important;
        
      }
</style>
<style lang="scss" scoped>
.cardtemplate {
  padding: 10px;
  box-sizing: border-box;
  .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
  .toptxt{
          padding-bottom: 20px;
    font-size: 14px;
    color: #333;
  }
  .body{
      overflow: auto;
      .body-box{
        margin: 10px auto;
        .box-top{
           height: 20px;
    line-height: 20px;
    margin: 10px 0;
    padding-left: 8px;
    border-left: 4px solid #409eff;
    color: #333;
        }
      }  
      .img{
        overflow: hidden;
        .img-box{
          float: left;
          width: 300px;
          margin: 10px;
          position: relative;
          height: 200px;
          border: 1px dashed #409EFF;
          background: #efefef;
          overflow: hidden;
          .hou{
            width: 100%;
            height: 100%;
          }
          .qian{
            position: absolute;
            left: 0;
            top:0;
            right: 0;
            bottom:0;
            width: 100%;
            height: 100%;
          }
        }
        .urlimg{
            float: left;
            margin: 10px;
            width: 300px;
        }
      }   
  }
 
}
</style>





// WEBPACK FOOTER //
// src/views/schoolRoadTeamPackage/schoolRoadTeamPackageimglist.vue